import React from 'react';
import MarkdownDocPage from '../../components/docs/MarkdownDocPage';
import content from '../../content/sentry-docs/menu-reference/overview.md?raw';

const MenuReferenceOverview: React.FC = () => {
  return <MarkdownDocPage content={content} />;
};

export default MenuReferenceOverview;
